import { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Autocomplete,
  Checkbox,
  Chip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Status } from '../../../../../themes/Global';
import { YesNoSelector } from './YesNoSelector';
import Observation from '../../../../../components/Advanced/Modal/PatientModal/Observations';

const languages = ['English', 'Spanish', 'Creole'];

const WelcomeCampaignDetail = ({ modificar = {}, onSave }) => {
  const timestamp = new Date().toLocaleString();

  const defaultData = {
    Language: 'Pendiente',
    WelcomeCampaignOptions: [],
    Status: 'Pendiente',
    Comment: '',
    JobPossition: 'Pendiente',
    NeedToRegisterOEP: 'NO',
    OEPOptions: '',
    ReleatedComments: [],
    PCPSpecialty: '',
    StaffName: 'Pendiente',

    // Campos de solo lectura
    OfficeLocation: 'Pendiente',
    MemberID: 'Pendiente',
    InsuranceStatus: 'Pendiente',
    MemberName: 'Pendiente',
    MemberPhoneNumber: 'Pendiente',
    MemberMobileNumber: 'Pendiente',
    AddressLine1: 'Pendiente',
    HealthStatus: 'Pendiente',
    MemeberPolicyID: 'Pendiente',
    CipID: 'Pendiente',
    DOB: 'Pendiente',
    Age: 'Pendiente',
    Gender: 'Pendiente',
    NetworkCode: 'Pendiente',
    NetworkName: 'Pendiente',
    MetalLevel: 'Pendiente',
    MemberPlan: 'Pendiente',
    MemberPlanEffectiveDate: 'Pendiente',
    NewMember: 'Pendiente',
    GroupNumber: 'Pendiente',
    CityName: 'Pendiente',
    ZipCode: 'Pendiente',
    County: 'Pendiente',
    Conditions: 'Pendiente',
    GlobalIndicator: 'Pendiente',
    Inpatient: 'Pendiente',
    InpatientReadmissions: 'Pendiente',
    EREvents: 'Pendiente',
    PreventableER: 'Pendiente',
    Medications: 'Pendiente',
    RecentLabs: 'Pendiente',
    LastVisitTimeframe: 'Pendiente',
    PCPProvider: 'Pendiente',
    PCPNPI: 'Pendiente',
    PCPFullName: 'Pendiente',
    PCPDegree: 'Pendiente',
    Update: 'Pendiente',
    GlobalIndicatorConcatenate: 'Pendiente',
    MonthYear: 'Pendiente'
  };

  const paciente = { ...defaultData, ...modificar };

  const [isEditing, setIsEditing] = useState(false);
  const [comments, setComments] = useState(paciente.ReleatedComments);
  const [openCommentDialog, setOpenCommentDialog] = useState(false);
  const [newComment, setNewComment] = useState('');
  const [selectedOptions, setSelectedOptions] = useState(paciente.WelcomeCampaignOptions);

  const [form, setForm] = useState({
    Language: paciente.Language,
    WelcomeCampaignOptions: paciente.WelcomeCampaignOptions,
    Status: paciente.Status,
    Comment: paciente.Comment,
    JobPossition: paciente.JobPossition,
    NeedToRegisterOEP: paciente.NeedToRegisterOEP,
    OEPOptions: paciente.OEPOptions,
    ReleatedComments: paciente.ReleatedComments,
    PCPSpecialty: paciente.PCPSpecialty
  });

  useEffect(() => {
    setForm(prev => ({ ...prev, WelcomeCampaignOptions: selectedOptions }));
  }, [selectedOptions]);


  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleAddComment = () => {
    const newEntry = {
      Timestamp: timestamp,
      Comments: newComment,
      StaffName: paciente.StaffName,
    };
    const updated = [...comments, newEntry];
    setComments(updated);
    handleChange('ReleatedComments', updated);
    setNewComment('');
    setOpenCommentDialog(false);
  };

  const handleSave = () => {
    const envio = { ...paciente, ...form, Update: timestamp };
    onSave(envio);
  };

  const display = (value) => value || 'Pendiente';

  return (
    <Container maxWidth="xl">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">Welcome Campaign Details</Typography>
        {!isEditing && (
          <Button variant="contained" startIcon={<EditIcon />} onClick={() => setIsEditing(true)}>Edit</Button>
        )}
      </Box>

      {/* Sección 1 */}
      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Grid container spacing={2}>
          <Grid item width="100%"><Typography><strong>Office Location:</strong> {display(paciente.OfficeLocation)}</Typography></Grid>
          <Grid item width="100%"><Typography><strong>Member ID:</strong> {display(paciente.MemberID)}</Typography></Grid>
          <Grid item width="100%"><Typography><strong>Insurance Status:</strong> {display(paciente.InsuranceStatus)}</Typography></Grid>
          <Grid item width="100%"><Typography><strong>Member Name:</strong> {display(paciente.MemberName)}</Typography></Grid>
          <Grid item width="100%"><Typography><strong>Patient Primary Language:</strong></Typography></Grid>
          <TextField
            select
            disabled={!isEditing}
            fullWidth
            value={form.Language}
            onChange={e => handleChange('Language', e.target.value)}
          >
            {languages.map(opt => (
              <MenuItem key={opt} value={opt}>{opt}</MenuItem>
            ))}
          </TextField>
          <Grid item width="100%"><Typography><strong>Member Phone Number:</strong> {display(paciente.MemberPhoneNumber)}</Typography></Grid>
          <Grid item width="100%"><Typography><strong>Member Mobile Number:</strong> {display(paciente.MemberMobileNumber)}</Typography></Grid>
          <Grid item width="100%"><Typography><strong>Address Line 1:</strong> {display(paciente.AddressLine1)}</Typography></Grid>

          <Autocomplete
            disabled={!isEditing}
            fullWidth
            multiple
            options={["CALL", "EMAIL", "TEXT", "VIDEO", "PENDING"]}
            disableCloseOnSelect
            value={selectedOptions}
            onChange={(event, newValue) => setSelectedOptions(newValue)}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox checked={selected} style={{ marginRight: 8 }} />
                {option}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" placeholder="Search" />
            )}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip key={option} label={option} {...getTagProps({ index })} />
              ))
            }
          />

          <TextField
            disabled={!isEditing}
            label="Status"
            select
            fullWidth
            value={form.Status}
            onChange={e => handleChange('Status', e.target.value)}
          >
            {Status.map(opt => (
              <MenuItem key={opt} value={opt}>{opt}</MenuItem>
            ))}
          </TextField>
        </Grid>
      </Paper>

      {/* Sección 2 */}
      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Grid container spacing={2}>
          {[
            'HealthStatus', 'MemeberPolicyID', 'CipID', 'DOB', 'Age', 'Gender',
            'NetworkCode', 'NetworkName', 'MetalLevel', 'MemberPlan',
            'MemberPlanEffectiveDate', 'NewMember', 'GroupNumber', 'CityName',
            'ZipCode', 'County', 'Conditions', 'GlobalIndicator', 'Inpatient',
            'InpatientReadmissions', 'EREvents', 'PreventableER', 'Medications',
            'RecentLabs', 'LastVisitTimeframe', 'PCPProvider', 'PCPNPI',
            'PCPFullName', 'PCPDegree', 'Update', 'GlobalIndicatorConcatenate',
            'MonthYear'
          ].map(key => (
            <Grid item width="100%" key={key}>
              <Typography><strong>{key.replace(/([A-Z])/g, ' $1')}:</strong> {display(paciente[key])}</Typography>
            </Grid>
          ))}

          <Grid item width="100%"><Typography><strong>PCP Specialty:</strong></Typography></Grid>
          <TextField
            disabled={!isEditing}
            fullWidth
            value={form.PCPSpecialty}
            onChange={e => handleChange('PCPSpecialty', e.target.value)}
          />

          <Grid item width="100%"><Typography><strong>Job Position:</strong></Typography></Grid>
          <TextField
            disabled={!isEditing}
            fullWidth
            value={form.JobPossition}
            onChange={e => handleChange('JobPossition', e.target.value)}
          />

          <YesNoSelector
            disabled={!isEditing}
            label="Need To Register OEP Campaign Option?"
            name="NeedToRegisterOEP"
            options={["NO", "YES"]}
            value={form.NeedToRegisterOEP}
            onChange={(name, option) => handleChange(name, option)}
          />

          {form.NeedToRegisterOEP === "YES" && (
            <TextField
              disabled={!isEditing}
              label="OEP Options"
              fullWidth
              value={form.OEPOptions}
              onChange={e => handleChange('OEPOptions', e.target.value)}
            />
          )}
        </Grid>
      </Paper>

      {/* Related Comments */}
      <Paper variant="outlined" sx={{ p: 4, mb: 3}}>
        <Box sx={{ display: "flex", flex: 1, overflow: "hidden" }}>
          <Box sx={{ flex: 1, p: 2, overflowY: "auto" }}>
            <Observation cipId={modificar.CipID} />
          </Box>
        </Box>
      </Paper>
      

      {isEditing && (
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button variant="outlined" onClick={() => setIsEditing(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>Save</Button>
        </Box>
      )}

      {/* Dialog para nuevo comentario */}
      <Dialog open={openCommentDialog} onClose={() => setOpenCommentDialog(false)}>
        <DialogTitle>Add Comment</DialogTitle>
        <DialogContent>
          <TextField
            label="Comment"
            fullWidth
            multiline
            rows={4}
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCommentDialog(false)}>Cancel</Button>
          <Button onClick={handleAddComment} variant="contained">Add</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default WelcomeCampaignDetail;
